import { useQuery } from 'react-query';

import { axios } from 'lib/axios';

const getDPSSettings = async (dpsId) => {
  const {
    data: { data: settings },
  } = await axios.get(`/api/dps/${dpsId}/settings`);
  return settings;
};

export const useDPSSettings = (dpsId, queryOptions = {}) =>
  useQuery(['dps-settings', dpsId], () => getDPSSettings(dpsId), {
    initialData: [],
    enabled: !!dpsId,
    ...queryOptions,
  });
